module.exports = __webpack_public_path__ + "img/noun-skill-shield-penetrate-2360219.f7cf0cc8.svg";